// extracted by mini-css-extract-plugin
export var container = "_g5-0";
export var icon = "_g5-1";
export var text = "_g5-2";